"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useLabels } from "@/lib/labels/LabelsProvider";
const SPORT_EMOJI = {
  football: "⚽",
  basketball: "🏀",
  tennis: "🎾",
  hockey: "🏒",
  american_football: "🏈"
} as const;
type KnownSport = keyof typeof SPORT_EMOJI;
function isKnownSport(value: string): value is KnownSport {
  return value in SPORT_EMOJI;
}

/** Maps SPORT_EMOJI keys (matching the FU livescore endpoint's lowercased sport codes) to label paths. */
const SPORT_LABEL_KEY = {
  football: "football",
  basketball: "basketball",
  tennis: "tennis",
  hockey: "hockey",
  american_football: "americanFootball"
} as const satisfies Record<KnownSport, string>;
interface SportBadgeProps {
  sport: string | undefined;
  className?: string;
}
export const SportBadge: React.FC<SportBadgeProps> = t0 => {
  const $ = _c(4);
  const {
    sport,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const labels = useLabels();
  if (!sport) {
    return null;
  }
  const key = sport.toLowerCase();
  if (!isKnownSport(key)) {
    return null;
  }
  const sportName = labels.livescore.sports[SPORT_LABEL_KEY[key]];
  const t2 = `inline-flex items-center leading-none ${className}`;
  const t3 = SPORT_EMOJI[key];
  let t4;
  if ($[0] !== sportName || $[1] !== t2 || $[2] !== t3) {
    t4 = <span className={t2} title={sportName} aria-label={sportName}>{t3}</span>;
    $[0] = sportName;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};